import styled from 'styled-components'
import breakpoints from './breakpoints'
import { IStyleElement } from '~/types/types'

interface Props extends IStyleElement {
  height?: string
  width?: string
  flex?: boolean
  column?: boolean
  justify?: string
  align?: string
  padding?: string
  margin?: string
  bg?: string
}

const Box = styled.div<Props>`
  position: relative;
  padding: ${p => p.padding || '0'};
  margin: ${p => p.margin || '0'};
  height: ${props => props.height || '100%'};
  width: ${props => props.width || ''};
  display: ${props => props.flex ? 'flex' : 'block'};
  flex-direction: ${props => props.column ? 'column' : 'row'};
  justify-content: ${props => props.justify};
  align-items: ${props => props.align};
  background-color: ${p => p.bg || ''};
  ${p => p.xsStyle}
  ${breakpoints.sm} {
    ${p => p.smStyle}
  }
  ${breakpoints.md} {
    ${p => p.mdStyle}
  }
  ${breakpoints.lg} {
    ${p => p.lgStyle}
  }
  ${breakpoints.xl} {
    ${p => p.xlStyle}
  }
`

export default Box